import { useState } from 'react';
import { ArrowRight } from '../Icons/ArrowRight';
import { AccordionLayoutProps } from './types';

export const AccordionLayout = ({ title, children, index, activeIndex, setActiveIndex }: AccordionLayoutProps) => {
    const [showItem, setShowItem] = useState(false);
    const toggleAccordionClick = () => {
        setShowItem(!showItem);
    };

    const handleSetIndex = (index: any): any => activeIndex !== index && setActiveIndex(index);

    return (
        <>
            <button
                type="button"
                onClick={() => {
                    handleSetIndex(index);
                    toggleAccordionClick();
                }}
                className="w-[calc(100%+4px)] bg-primary hover:bg-white focus-visible:bg-white border-2 border-primary rounded-md flex items-center justify-between font-w-button hover:text-primary focus-visible:text-primary text-on-primary text-sm text-left -m-2px px-2 py-3 transition-color ease-in-out duration-200"
            >
                <div className="">{title}</div>
                <ArrowRight
                    classNames={`flex-none h-auto w-2.5 ml-2 fill-transparent stroke-current ${activeIndex === index && showItem && 'rotate-90'}`}
                />
            </button>

            {activeIndex === index && showItem && <div>{children}</div>}
        </>
    );
};
